'use client';

import { useEffect, useRef, useState } from 'react';
import { Search } from 'lucide-react';

interface SearchBarProps {
  onSearch: (query: string) => void;
  resultCount?: number;
}

export default function SearchBar({ onSearch, resultCount }: SearchBarProps) {
  const [query, setQuery] = useState('');
  const debounceRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!query.trim()) return;

    debounceRef.current = setTimeout(() => {
      onSearch(query.trim());
    }, 300);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [query, onSearch]);

  return (
    <div>
      <div
        className="flex items-center gap-3 px-5 py-4 rounded-xl"
        style={{
          backgroundColor: 'var(--bg-card)',
          border: '1px solid rgba(200, 164, 94, 0.15)',
        }}
      >
        <Search size={20} style={{ color: 'var(--accent-gold)' }} />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search the Bible semantically..."
          className="flex-1 bg-transparent text-base outline-none placeholder:text-white/25"
          style={{ color: 'var(--text-primary)' }}
        />
      </div>
      {resultCount !== undefined && query.trim() && (
        <p
          className="text-xs mt-2 ml-1"
          style={{ color: 'var(--text-secondary)' }}
        >
          {resultCount} result{resultCount !== 1 ? 's' : ''} found
        </p>
      )}
    </div>
  );
}
